import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { PRIVACY } from "@/lib/privacyContent";

export default function Privacy() {
  const { lang, t } = useLang();
  const c = PRIVACY[lang] || PRIVACY.en;
  const email = process.env.REACT_APP_CONTACT_EMAIL;

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-8 py-10" data-testid="privacy-page">
      <header className="mb-10">
        <div className="inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.2em] text-ochre font-semibold mb-3">
          <ShieldCheck className="w-4 h-4" /> {t("app_title")}
        </div>
        <h1 className="text-4xl sm:text-5xl font-display font-bold text-ink tracking-tight" data-testid="privacy-title">{c.title}</h1>
        <p className="mt-3 text-muted-foreground text-sm">{c.updated}: 7 {c.month} 2026</p>
      </header>

      <div className="space-y-8">
        {c.sections.map((s, i) => (
          <section key={s.h} className="border-t border-stoneLine/70 pt-6" data-testid={`privacy-section-${i}`}>
            <h2 className="text-base md:text-lg font-display font-bold text-ink mb-2">{s.h}</h2>
            {s.p.map((para) => (
              <p key={para.slice(0, 40)} className="text-sm leading-relaxed text-ink/85 mb-2">{para.replace("{email}", email)}</p>
            ))}
            {s.list && (
              <ul className="list-disc ps-5 space-y-1 text-sm text-ink/85">
                {s.list.map((li) => <li key={li}>{li}</li>)}
              </ul>
            )}
          </section>
        ))}
        <section className="border-t border-stoneLine/70 pt-6" data-testid="privacy-contact">
          <h2 className="text-base md:text-lg font-display font-bold text-ink mb-2">{c.contact}</h2>
          <a href={`mailto:${email}`} className="text-sm text-ochre hover:underline" data-testid="privacy-email">{email}</a>
          <div className="mt-3"><Link to="/elimina-dati" className="inline-flex items-center gap-1.5 rounded-full border border-red-600/40 text-red-700 px-4 py-1.5 text-sm font-semibold hover:bg-red-600/10" data-testid="privacy-delete-link">🗑 {c.sections.find((s) => s.h.includes("limina") || s.h.includes("elete") || s.h.includes("upprimer") || s.h.includes("حذف"))?.h}</Link></div>
        </section>
      </div>

      <Link to="/" className="inline-block mt-10 text-sm text-ochre hover:underline" data-testid="privacy-back">← {t("map")}</Link>
    </div>
  );
}
